import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Form, Table } from 'react-bootstrap';
import { AttachMoney } from '@material-ui/icons';
import { api } from 'services';
import MasterPage from '../MasterPage';

const Financial = () => {
	const [fiscalYear, setFiscalYear] = useState(2021)
	const [funds, setFunds] = useState([
		{ name: "MDF", type: "mdf", value: 0},
		{ name: "BU", type: "bu", value: 0 },
		{ name: "OWN", type: "own", value: 0 },
		{ name: "Extra", type: "extra", value: 0 },
		{ name: "Total", type: "total", value: 0 }
	]);

	useEffect(() => {
		getFunds()
	}, [fiscalYear])


	const getFunds = async () => {
		await api.get('funds/total-collected', { 
				params: { fiscal_year: fiscalYear }
			})
			.then(({ data }) => {
				let newData = funds.map(fund => (
					{ ...fund, value: data[`value_${fund.type}`] }
				))
				setFunds(newData)
			})
	}

	const formatValue = value => {
		return Intl.NumberFormat('pt-Br', { 
			style: 'currency', 
			currency: 'BRL' 
		})
		.format(value)
	}

	return (
		<Card.Body className="shadow bg-white rounded mb-3">
			<Row>
				<Col className="d-flex mt-3 mb-3">					
					<AttachMoney className="icon-title" />
					<h4 className="title-dashboard mt-2">Financeiro - Total por tipo de verba</h4>
				</Col>
			</Row>
			<Row className="mt-2">
				<Col md={6}>
					<Form.Group>
						<Form.Label>Ano Fiscal:</Form.Label>
						<Form.Control
							as="select"
							value={fiscalYear}
							onChange={(e) => {
								setFiscalYear(e.target.value)
							}}							
						>
							<option value={2021}>2021</option>
							<option value={2020}>2020</option>
							<option value={2019}>2019</option>
						</Form.Control>
					</Form.Group>
				</Col>				
			</Row>
			<Row>
				<Col><hr/></Col>
			</Row>
			<Row>
				<Col md={12}>
					<Table bordered>
						<thead>
							<th>
							</th>
							{funds.map((fund) => (
								<th key={fund.type} className="text-center">{ fund.name }</th>
							))}
						</thead>
						<tbody>
							<tr>
								<th>Valor</th>
								{funds.map((fund) => (
									<td key={fund.type} className="text-center">{ formatValue(fund.value) }</td>
								))}
							</tr>
						</tbody>
					</Table>
				</Col>
				{/* {funds.map(fund => (
					<Col className="bg-white font-weight-bold rounded m-2 p-5 d-flex align-items-center flex-column">
						<img className="d-inline-block mb-3" src={fund.icon} width="50" />
						<p>{ fund.name }</p>
						<p>{ formatValue(fund.value) }</p>
					</Col>
				))} */}
			</Row>
		</Card.Body>
	)
}

export default MasterPage(Financial);